<template>
  <div class="loader">

<van-space direction="vertical" fill>

  <van-image
    :show-loading = false
      width="20rem"
      fit="contain"
      src="https://admin-jarretiere.gigamedia.net/images/logo/logo-GGM-SmartBS-bleu.svg"
    />

    <!-- Deux cases avec des images personnalisées -->
    <van-list class="m-t2 m-l-4">
        <!-- Deuxième case -->
        <van-cell class="large-card cell_card_co_a style_card all_border_radius" clickable @click="sendData">
        <van-row class="row_card center-content">
          <van-col class="d-content center-content" span="2">
            <van-image
              class="img_inher img_choice_config"
              width="200px"
            
              position="left"
              :src="this.$store.state.storeGlobal.StoreApi + '/images/infos/back_choice_fib.jpg'"
            />
          </van-col>
          <van-col  class="center-content">
            <span style="margin-top: 10px;">
              <span class="title_card">{{$t('Configurateur trunk optique')}}</span>
              <br>
              <div class="subtitle_card">{{$t('(Câbles préconnectorisés avec chaussette de tirage)')}}</div>  
            </span>
          </van-col>
        </van-row>
      </van-cell>

      <!-- Première case -->
      <van-cell class="large-card cell_card_co_a style_card all_border_radius" clickable @click="redirectToInitialData">
        <van-row class="row_card center-content">
          <van-col class="d-content center-content" span="2">
            <van-image
              :href="initialData"
              class="img_inher img_choice_config"
              width="200px"
              
              position="left"
              :src="this.$store.state.storeGlobal.StoreApi + '/images/infos/back_choice_jar.png'"
            />
          </van-col>
          <van-col  class="center-content">
            <span style="margin-top: 10px;">
             <span class="title_card">{{$t('Configurateur jarretière optique')}}</span>
             <br>
             <div class="subtitle_card">{{$t('(Câbles 1 ou 2F.O., pour pose)')}}</div>           
            </span>
           
          </van-col>
        </van-row>
      </van-cell>

    
    </van-list>

    <van-image
    class="load_pret_logo"
    :show-loading = false
      width="13rem"
      fit="contain"
      src="https://admin-jarretiere.gigamedia.net/images/logo/picto_pre-t.svg"
    />

  </van-space>


</div>

</template>

<script>
export default {
  props: ['initialData'],
  methods: {
    sendData() {
      this.$emit('dataSent', true);
    },
    redirectToInitialData() {
      document.location.href=this.initialData;
    }
  }
}
</script>

<style scoped>
.spinner .color-load {
  color: rgba(1, 69, 140, 1.000);
}
.title_card{
  font-size: 1.2rem;
  font-weight: bold;
}
.subtitle_card{
  font-size: 1rem;
  margin-top: 5px;
}
/* Absolute Center Spinner */
.loader {
  position: fixed;
    z-index: 999;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    text-align: center;
    height: 77vh;
}

/* Flexbox centering */
.center-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
.align_person {
  text-align: center;
}
.img_choice_config {
  height: 238px !important;
    width: auto !important;
    display: block !important;
} 
/* Large card style */
.large-card {
  padding-top: 0px !important;
  width: 100% !important;
  max-width: 350px !important; /* Adjust this value as needed */
  height: 340px; /* Adjust this value as needed */
  margin: 1rem auto; /* Center the card horizontally */
}
</style>